import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transferproduct',
  templateUrl: './transferproduct.component.html',
  styleUrls: ['./transferproduct.component.css']
})
export class TransferproductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
